
<ng-container *ngIf="!catalogPageData">
  <div class="banner-wrapper skeleton">
    <app-skeleton/>
  </div>
</ng-container>


<div *ngIf="catalogPageData" class="banner-wrapper">
  <div class="left-back">
    <img
      alt=""
      loading="lazy"
      src="/Content/Images/triangles/tr6.png?format=webp"
    />
  </div>
  <picture class="middle-back">
    <source
      media="(min-width: 640px)"
      srcset="/Content/Images/pics/lobby.jpg?format=webp"
      data-srcset="/Content/Images/pics/lobby-mob.jpg?format=webp"
      data-loaded="true"
      class="lazy"
    />
    <img
      alt="Lobby Mob"
      loading="lazy"
      src="/Content/Images/pics/lobby-mob.jpg?format=webp"
    />
  </picture>
  <div class="right-back"></div>
  <div class="banner-container">
    <div class="banner-container__body">
      <h1 class="title">{{ catalogPageData.title }}</h1>
      <div class="description">
        {{ catalogPageData.description }}
      </div>
    </div>
  </div>
</div>

<div class="catalog-container">
  <app-search-field
    *ngIf="catalogPageData"
    (searchQueryChange)="onSearchInputChange($event)"
    (onSubmitObj)="onAutoselectInputSubmit($event)"
    (onSubmit)="onSearchInputSubmit()"
    (openCloseMobilePopup)="changeSidebarMenu($event)"
    [placeholder]="catalogPageData?.searchPlaceHolder"
    [isMobile]="isMobile"
    [mainCatalogId]="catalogPageData?.nodeId"
    [childNodeId]="childNodeId"
    [apiEndpointUrl]="'/Portal/Catalog-Api/GetPortalAutocomplete'"
  ></app-search-field>

  <div *ngIf="!catalogPageData" class="form-wrapper search-bar-skeleton">
    <app-skeleton/>
  </div>

  <div class="catalog-wrapper">
    <div class="search-catalog">
      <div class="search-catalog__filters" *ngIf="catalogPageData" [ngClass]="{'hide-mobile': isMobile}">
        <div class="filters-top-section">
          <div class="search-catalog__filters-header">{{catalogPageData.filtersSectionTitle}}</div>
          <button class="clear-button link" (click)="clearAllParams()">
            {{catalogPageData.mobileFiltersClearBtnText}}
          </button>
        </div>
            <label
              class="checkbox-item custom-checkbox-component"
              for="registration-check-box"
            >
              <input
                id="registration-check-box"
                type="checkbox"
                [checked]="showFavoritesOnly"
                (change)="favoritesFilterCheckBoxChanged($event)"
              />

              <span class="checkbox-item__check" ></span>

              <span class="checkbox-item__label">{{ catalogPageData.favoritesFilterText }}</span>
            </label>

        <app-expansion-panel
          *ngFor="let filterGroup of catalogPageData.filters"
          [title]="filterGroup.filterGroupTitle"
          [filters]="filterGroup.filters"
          [isExpanded]="filterGroup.openPanelByDefault"
          [selectedFilters]="filters"
          [selectedDepartmentsFilters]="departmentsFilters"
          [selectedFacultiesFilters]="facultiesFilters"
          (filterStatusChanged)="
            onFilterStatusChange($event.event.checked, $event.filter)
          "
          [isUsePersonalizationFilters]="true"
        ></app-expansion-panel>
      </div>

      <div class="search-catalog__filters skeleton" *ngIf="!catalogPageData" [ngClass]="{'hide-mobile': isMobile}">
        <div class="search-catalog__filters-header"><app-skeleton [type]="'text'" [symbolsCount]="6"/></div>
        <div class="skeleton-filter-group" *ngFor="let _ of [].constructor(4)">
          <app-skeleton [type]="'text'" [symbolsCount]="8"/>
        </div>
      </div>

      <div class="search-catalog__filters-popup" *ngIf="catalogPageData" [ngClass]="{'hide-mobile': !isMobile}">
        <div class="slide-up-header" (click)="openFiltersMobilePopup()">
          <div class="filter-icon">
            <img src="/Content/Images/icons/filter.svg" alt="" width="36" height="36" />
          </div>
          <div class="filter-text">{{catalogPageData.filtersSectionTitle}}</div>
        </div>
        <div class="catalog-filters-mobile" *ngIf="showFiltersMobileModal">
          <div class="catalog-filters-mobile__content">
            <span class="close" (click)="closeFiltersMobilePopup()">
              &times;
            </span>
            <div class="slide-up-header">
              <div class="filter-icon">
                <img src="/Content/Images/icons/filter.svg" alt="" width="36" height="36" />
              </div>
              <div class="filter-text">{{catalogPageData.filtersSectionTitle}}</div>
            </div>
            <div class="slide-up-filters-content">
              <label
                class="checkbox-item custom-checkbox-component"
                for="registration-check-box-mobile"
              >
                <input
                  id="registration-check-box-mobile"
                  type="checkbox"
                  [checked]="showFavoritesOnly"
                  (change)="favoritesFilterCheckBoxChanged($event)"
                />

                <span class="checkbox-item__check"></span>

                <span class="checkbox-item__label">{{ catalogPageData.favoritesFilterText }}</span>
              </label>

              <app-expansion-panel
                *ngFor="let filterGroup of catalogPageData.filters"
                [title]="filterGroup.filterGroupTitle"
                [filters]="filterGroup.filters"
                [isExpanded]="filterGroup.openPanelByDefault"
                [selectedFilters]="filters"
                [selectedDepartmentsFilters]="departmentsFilters"
                [selectedFacultiesFilters]="facultiesFilters"
                [isUsePersonalizationFilters]="true"
                (filterStatusChanged)="onFilterStatusChange($event.event.checked, $event.filter)"
              ></app-expansion-panel>
            </div>
            <div class="slide-up-filters-bottom">
              <div class="slide-up-filters-bottom__text">
                {{catalogPageData.totalSearchResultCounterFormat}} {{this.catalogPageData.searchResults.totalSearchResultsCount}}
              </div>
              <button class="slide-up-filters-bottom__clear-btn link" (click)="clearFilters($event)" [disabled]="getFiltersEnableStatus()">
                {{catalogPageData.mobileFiltersClearBtnText}}
              </button>
              <button class="slide-up-filters-bottom__search-submit" (click)="closeFiltersMobilePopup()">
                {{catalogPageData.mobileFiltersShowBtnText}}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="search-catalog__filters-popup" *ngIf="!catalogPageData" [ngClass]="{'hide-mobile': !isMobile}">
        <div class="slide-up-header">
          <app-skeleton [height]="36" [width]="120"/>
        </div>
      </div>
      <div class="search-catalog__result">
        <app-catalog
          [resultText]="catalogPageData?.totalSearchResultCounterFormat"
          [noResultsTitle]="catalogPageData?.noResultsTitle"
          [noResultsText]="catalogPageData?.noResultsText"
          [noResultsImage]="catalogPageData?.noResultsImageUrl"
          [clearAllText]="catalogPageData?.noResultsClearAllBtnText"
          [pageSize]="catalogPageData?.pageSize"
          [cards]="catalogPageData?.searchResults?.cards"
          [totalSearchResultsCount]="catalogPageData?.searchResults.totalSearchResultsCount"
          [currentPage]="currentPage"
          [isLoading]="isLoading"
          (pageChange)="onPageChange($event)"
          (clearAllBtnClick)="clearAllParams()"
          (favoriteToggle)="favoriteSave($event)"
        ></app-catalog>
      </div>
    </div>
  </div>
</div>
